import { useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';

// Inicia a inspeção das lâminas — quem inspeciona é o inspetor (perm edit_inspection).
const StartSpreadInspectionButton = ({ order }) => {
  const { hasPermissions } = useContext(AuthContext);

  return (
    <>
      {order.order_status === 'Lâminas editadas' &&
        hasPermissions([
          'edit_inspection',
          'edit_order',
          'seller_inspection',
        ]) && (
          <div className="col-sm col-md-6 col-xl-4 mt-2">
            <button
              className="btn btn-success btn-block col-12"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#modal-start-spread-inspection-order"
            >
              iniciar inspeção de lâminas
            </button>
          </div>
        )}
    </>
  );
};

StartSpreadInspectionButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
  }).isRequired,
};

export default StartSpreadInspectionButton;
